import React from 'react';
import { Controller } from 'react-hook-form';
import { TextFieldProps } from '@mui/material';
import { FieldNotify, SelectOption } from 'global';
import { Control } from 'react-hook-form/dist/types/form';
import { FieldValues } from 'react-hook-form/dist/types/fields';
import { UseControllerProps } from 'react-hook-form/dist/types/controller';

import { FormInputSelect } from '../FormInputSelect';

interface Props<
  FormValues extends FieldValues = FieldValues,
  OptionValue extends string | number | boolean = string,
> extends Omit<TextFieldProps, 'select' | 'onChange'> {
  label?: string;
  isLoading?: boolean;
  notify?: FieldNotify;
  placeholder?: string;
  options: SelectOption<OptionValue>[];
  control: Control<FormValues>;
  extraAction?: (nextValue: string | number | boolean) => void;
  name: UseControllerProps<FormValues>['name'];
}

export const SelectField = <
  FormValues extends FieldValues = FieldValues,
  OptionValue extends string | number | boolean = string,
>({
  name,
  label,
  options,
  control,
  extraAction,
  isLoading = false,
  notify,
  ...other
}: Props<FormValues, OptionValue>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, onChange, ...field }, fieldState }) => (
        <FormInputSelect<OptionValue>
          label={label}
          variant="standard"
          notify={notify}
          options={options}
          isLoading={isLoading}
          {...other}
          {...field}
          error={!!other?.error || !!fieldState.error}
          inputRef={ref}
          onChange={value => {
            onChange(value);
            extraAction?.(value);
          }}
        />
      )}
    />
  );
};
